import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIService } from '../apiservices/apiservices';

@Injectable()
export class TokensProvider {
  private header=APIService.getHeader();
  itemret;

  constructor(public http: HttpClient) {
    ////console.log('Hello AgendaProvider Provider');
  }
  
  setTokens(usuario, nome, cpf, numeroCelular, email, diasLimite, dispositivo, accessType) {
    var me=this;
    this.header=APIService.getHeader();
    const userAgent = navigator.userAgent;

    return new Promise((resolve, reject) => {
      var data = {
        "usuario":usuario,
        "nome": nome, 
        "numeroCelular":numeroCelular,
        "email":email,
        "cpf":cpf,
        "versao":"109",
        "userAgent":userAgent,
        "diasLimite":diasLimite,
        "dispositivo":dispositivo,
        "tipoAcesso":accessType
      };
  
      var requestData=JSON.stringify(data);
      let url = APIService.API_URL + 'tokens';
      console.log("CHAMADA TOKEN " + url);

      me.http.post(url,requestData,{headers:me.header})
        .subscribe((result: any) => {
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na geração dos tokens.'
              }
              me.itemret=errodatavazio;
            }
            
            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Não há consultas.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error._body;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }

  setMfa(usuario, nome, cpf, numeroCelular, email, diasLimite, dispositivo, accessType) {
    this.header = APIService.getHeader();
    const userAgent = navigator.userAgent;

    return new Promise((resolve, reject) => {

      const data = {
        usuario,
        nome,
        numeroCelular,
        email,
        cpf,
        versao: "109",
        userAgent,
        diasLimite,
        dispositivo,
        tipoAcesso: accessType,
      };

      const url = APIService.API_URL + 'tokens?operacao=mfaTemp';

      this.http.post(url, data, { headers: this.header })
        .subscribe({
          next: (result: any) => {

            if (result && Object.keys(result).length > 0) {

              if (result.status_ret !== "NOK") {
                resolve({
                  Item: result,
                  erro: ''
                });
              } else {
                reject({
                  Item: null,
                  erro: 'Erro na geração dos tokens.'
                });
              }

            } else {
              reject({
                Item: null,
                erro: 'Não há consultas.'
              });
            }
          },

          error: (error) => {
            let msg = error.status === 401
              ? error.statusText
              : (error.error || error.message);

            reject({
              Item: null,
              erro: msg
            });
          }
        });
    });
  }

  refreshToken(tokenJwt) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      var data = {
        "tokenJwt":tokenJwt
        };
  
      var requestData=JSON.stringify(data);
      let url = APIService.API_URL + 'login';
      
      me.http.post(url,requestData,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result.json();

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na autenticação do serviço.'
              }
              me.itemret=errodatavazio;
            }
            
            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Não há consultas.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg="Entre com seu CPF e senha.";
          }
          else{
            msg=error._body;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
        });
    });
  }

}
